import { useState } from 'react';

export default function Home() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      icon: 'ri-scissors-line',
      title: 'セルフ脱毛',
      subtitle: 'セルフに特化した使い方が簡単',
      description: '痛みが少なくスピーディー。肌に優しい光でムダ毛をケア。メンズ・レディースどちらもOK。',
      keywords: 'セルフ脱毛 帯広 無人サロン'
    },
    {
      icon: 'ri-tooth-line',
      title: 'セルフホワイトニング',
      subtitle: '時間を取らない簡単な手順',
      description: 'ホワイトニング用ジェル+LED照射で、自然な白さへ。清潔感・第一印象アップ。',
      keywords: 'ホワイトニング 帯広 セルフ'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'セルフシミ取り',
      subtitle: 'ペンでなぞる低周波シミケア',
      description: 'ペンでなぞる低周波シミケアで、シミ・くすみ・毛穴へアプローチ。定期利用で明るい素肌をキープ。',
      keywords: 'シミ取り 帯広 美肌サロン'
    },
    {
      icon: 'ri-robot-line',
      title: 'AIパーソナルジム',
      subtitle: '北海道初導入',
      description: '最新のAIパーソナルモニターとバーチャルマシンが連動。姿勢・体の歪みをAIが解析し、最適なトレーニングを提案。',
      keywords: 'AIジム 北海道 無人フィットネス'
    }
  ];

  const steps = [
    { number: '1', title: 'スマホで24時間予約決済', description: 'LINEまたはWebから' },
    { number: '2', title: 'QRで入室・完全無人', description: '自動ロックシステム' },
    { number: '3', title: '安心ガイド', description: '初めてでも簡単' },
    { number: '4', title: '個室でセルフ施術', description: 'トレーニング' },
    { number: '5', title: '自動退室', description: 'キャッシュレス対応' }
  ];

  const safetyFeatures = [
    { icon: 'ri-door-lock-line', title: '完全個室 × 自動ロック' },
    { icon: 'ri-shield-check-line', title: '自動消毒・換気システム常時稼働' },
    { icon: 'ri-camera-line', title: '防犯カメラ・AIセキュリティ完備' },
    { icon: 'ri-tools-line', title: '毎日メンテナンス・衛生管理実施' }
  ];

  const facilities = [
    {
      title: 'ピラティス',
      description:
        'ピラティスは、体の歪みを整えながら姿勢や柔軟性を高める運動です。呼吸に合わせて体を動かすことで、インナーマッスルを鍛え、体幹を安定させ、心身のバランスを整えます。初心者にもやさしく続けやすいのが特徴です。'
    }
    // ... other facilities can be added here ...
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1
                className="text-2xl font-bold text-gray-900"
                style={{ fontFamily: '"Pacifico", serif' }}
              >
                セルフマート
              </h1>
            </div>

            <nav className="hidden md:flex space-x-8">
              <a href="#services" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                サービス
              </a>
              <a href="#flow" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                ご利用の流れ
              </a>
              <a href="#pricing" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                料金
              </a>
              <a href="#access" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                アクセス
              </a>
            </nav>

            <a
              href="https://lin.ee/1kb2jkF"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              LINE予約
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section
        className="relative h-screen flex items-center justify-center text-white overflow-hidden"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)), url('https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/2c9498f5ea8832324892c439206ab98e.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="text-center max-w-7xl mx-auto px-4 z-10">
          <h2 className="text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-black mb-8 leading-none tracking-tight">
            <span
              className="block bg-gradient-to-r from-white via-yellow-100 to-white bg-clip-text text-transparent drop-shadow-2xl filter brightness-125"
              style={{
                fontFamily:
                  '"Rounded Mplus 1c", "Kosugi Maru", "M PLUS Rounded 1c", "Hiragino Maru Gothic Pro", "ヒラギノ丸ゴ Pro W4", "Meiryo", "メイリオ", "Comic Sans MS", cursive'
              }}
            >
              自分が変わると笑顔になる！！
            </span>
          </h2>

          <p className="mb-6 font-bold opacity-100 drop-shadow-lg filter brightness-110" style={{ fontFamily: '"Rounded Mplus 1c", "Kosugi Maru", "M PLUS Rounded 1c", "Hiragino Maru Gothic Pro", "ヒラギノ丸ゴ Pro W4", "Meiryo", "メイリオ", "Comic Sans MS", cursive' }}>
            <span className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-medium text-yellow-100">誰にも見られず、</span>
            <span className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-white">キレイとカラダ</span>
            <span className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium text-yellow-100">が進化する。</span>
          </p>

          <p className="mb-12 opacity-95 font-medium drop-shadow-md filter brightness-110" style={{ fontFamily: '"Rounded Mplus 1c", "Kosugi Maru", "M PLUS Rounded 1c", "Hiragino Maru Gothic Pro", "ヒラギノ丸ゴ Pro W4", "Meiryo", "メイリオ", "Comic Sans MS", cursive' }}>
            <span className="text-base md:text-lg lg:text-xl xl:text-2xl font-light text-yellow-100">北海道帯広発、</span>
            <span className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white">未来型</span>
            <span className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-medium text-yellow-100">セルフサロン。</span>
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="https://seruhuma-to.hacomono.jp/home"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 px-12 py-6 rounded-full text-2xl font-bold hover:from-yellow-500 hover:to-orange-500 transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer inline-block"
            >
              今すぐ予約
            </a>
          </div>
        </div>

        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-yellow-300/60 rounded-full animate-pulse" />
          <div className="absolute top-3/4 right-1/4 w-2 h-2 bg-orange-300/70 rounded-full animate-ping" />
          <div className="absolute bottom-1/3 left-1/3 w-2.5 h-2.5 bg-yellow-200/50 rounded-full animate-pulse delay-1000" />
          <div className="absolute top-1/2 right-1/3 w-1.5 h-1.5 bg-white/60 rounded-full animate-bounce delay-500" />
          <div className="absolute bottom-1/4 right-1/4 w-2 h-2 bg-orange-200/60 rounded-full animate-pulse delay-700" />
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 bg-teal-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h3 className="text-4xl font-bold text-gray-900 mb-16">料金プラン</h3>

          {/* チョコザップ風デザイン */}
          <div className="bg-white rounded-3xl shadow-xl p-8 max-w-4xl mx-auto mb-12">
            <div className="text-center mb-8">
              <div className="inline-block">
                <span className="text-lg text-gray-600 mr-2">ずーっと</span>
                <span className="text-5xl font-bold text-gray-900">月額</span>
                <span className="text-8xl font-bold text-orange-500 mx-4">5,980</span>
                <span className="text-3xl font-bold text-gray-900">円</span>
                <span className="text-lg text-gray-500 ml-2">[税込]</span>
              </div>
            </div>

            <div className="mb-8">
              <div className="text-2xl font-bold text-gray-900 mb-6">
                <span className="text-orange-500">【</span>
                <span className="mx-2">無人のセルフマートなら安心！</span>
                <span className="text-orange-500">】</span>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="bg-teal-50 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <span className="text-2xl font-bold text-teal-600">¥0</span>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">初期費用 ゼロ円*</h4>
                  <p className="text-sm text-gray-600">入会金・事務手数料不要</p>
                </div>

                <div className="bg-teal-50 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <i className="ri-checkbox-line text-3xl text-teal-600" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">月額だけで全部コミコミ</h4>
                  <p className="text-sm text-gray-600">あとからの請求なし</p>
                </div>

                <div className="bg-teal-50 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <i className="ri-shield-check-line text-3xl text-green-600" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">完全個室・完備のセキュリティ</h4>
                  <p className="text-sm text-gray-600">防犯カメラ・自動消毒・AI監視</p>
                </div>
              </div>
            </div>
          </div>

          {/* 従来のプランカード */}
          <div className="bg-white rounded-3xl shadow-xl p-12 max-w-2xl mx-auto">
            <div className="mb-8">
              <h4 className="text-3xl font-bold text-gray-900 mb-4">月額サブスク</h4>
              <div className="text-5xl font-bold text-teal-600 mb-2">¥5,980</div>
              <p className="text-gray-600">税込</p>
            </div>
            <div className="space-y-4 mb-8">
              <div className="flex items-center justify-center">
                <i className="ri-check-line text-teal-600 text-xl mr-3" />
                <span className="text-gray-700">脱毛・ホワイトニング・シミ取り・AIジムすべて利用OK</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-check-line text-teal-600 text-xl mr-3" />
                <span className="text-gray-700">一日一時間！毎日使い放題！</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-check-line text-teal-600 text-xl mr-3" />
                <span className="text-gray-700">（シンプル1プラン）</span>
              </div>
            </div>
            <a
              href="https://lin.ee/v0HtMo9"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-colors w-full whitespace-nowrap cursor-pointer inline-block text-center"
            >
              LINE登録で即スタート
            </a>
            <p className="text-sm text-gray-500 mt-4">検索: サブスク 美容 帯広</p>
          </div>
        </div>
      </section>

      {/* Concept Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h3 className="text-4xl font-bold text-gray-900 mb-8">コンセプト</h3>
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-gray-700 mb-6 leading-relaxed">
              北海道・帯広に誕生した、完全無人・完全個室の次世代ビューティースペース。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              「セルフ脱毛」「セルフホワイトニング」「シミ取りケア」そして、AIが導くパーソナルジム。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              そこに行けば美人になる！すべてを自分のペースで、誰にも見られず。
            </p>
            <p className="text-xl font-semibold text-teal-600">
              "通う"から、"自分で進化する時代"へ。
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h3 className="text-4xl font-bold text-center text-gray-900 mb-16">サービス内容</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow cursor-pointer border border-gray-100"
                onClick={() => setActiveService(index)}
              >
                <div className="w-full h-48 rounded-xl overflow-hidden mb-6">
                  <img
                    src={
                      index === 0
                        ? 'https://public.readdy.ai/ai/img_res/8ce4f55bb22163f8c637eac23a590116.jpg'
                        : index === 1
                        ? 'https://readdy.ai/api/search-image?query=Teeth%20whitening%20LED%20light%20therapy%20equipment%20in%20dental%20clinic%2C%20modern%20dental%20chair%2C%20professional%20whitening%20gel%20application%2C%20clean%20white%20medical%20environment%2C%20advanced%20dental%20technology%20setup&width=400&height=300&seq=service2&orientation=landscape'
                        : index === 2
                        ? 'https://readdy.ai/api/search-image?query=Professional%20pen-type%20spot%20removal%20device%20for%20skin%20treatment%2C%20handheld%20laser%20pigmentation%20removal%20tool%2C%20modern%20beauty%20clinic%20setting%2C%20precise%20skincare%20equipment%2C%20medical%20aesthetic%20pen%20device%20on%20clean%20white%20background&width=400&height=300&seq=service3pen&orientation=landscape'
                        : 'https://readdy.ai/api/search-image?query=AI-powered%20personal%20training%20gym%20equipment%20with%20digital%20screens%2C%20futuristic%20fitness%20technology%2C%20smart%20workout%20machines%2C%20modern%20gym%20interior%20with%20virtual%20reality%20elements%2C%20high-tech%20exercise%20environment&width=400&height=300&seq=service4&orientation=landscape'
                    }
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2 text-center">{service.title}</h4>
                <p className="text-sm text-teal-600 mb-4 text-center font-medium">{service.subtitle}</p>
                <p className="text-gray-600 text-center leading-relaxed">{service.description}</p>
                <div className="mt-4 text-xs text-gray-400 text-center">検索: {service.keywords}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h3 className="text-4xl font-bold text-center text-gray-900 mb-16">設備・サービス</h3>
          <div className="grid md:grid-cols-3 gap-8">
            {/* ピラティス */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/86cf30200ed841c365dd6193c567db2a.png"
                    alt="ピラティス"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">ピラティス</h4>
              <p className="text-gray-600 text-sm leading-relaxed">{facilities[0].description}</p>
            </div>

            {/* ウェイトトレーニング */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/5e1fe1333c88ed7537a972c5d58ee244.png"
                    alt="ウェイトトレーニング"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">ウェイトトレーニング</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                ウエイトトレーニングは、ダンベルやマシンを使って筋肉に負荷をかける運動です。基礎代謝を上げ、脂肪燃焼しやすい体を作ります。初心者でも安全に始められます。
              </p>
            </div>

            {/* シャワー室 */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/c53f61e40e1d0e70b5911afe9c98b21a.png"
                    alt="シャワー室"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">シャワー室</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                清潔で快適なシャワー室を完備。運動後の汗をすっきり洗い流し、リフレッシュできます。個室空間でプライバシーも安心です。
              </p>
            </div>

            {/* セルフ脱毛 */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/ef83705597cc7b9752a959bff0a28895.png"
                    alt="セルフ脱毛"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">セルフ脱毛</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                セルフ脱毛は、自分のペースでムダ毛ケアができる最新スタイルです。簡単操作で痛みも少なく、サロン級の仕上がりを実現。完全個室で安心して使用できます。
              </p>
            </div>

            {/* セルフシミケア */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/1934a645e264096ae94607aa4c109cf7.png"
                    alt="セルフシミケア"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">セルフシミケア</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                シミ取りは、気になるシミやくすみをケアし、明るい素肌へ導く施術です。最新マシンで肌への負担を抑え、安全かつ効果的に美肌を目指せます。
              </p>
            </div>

            {/* セルフホワイトニング */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/d9b0a00bc0dd37245c425d2cf76c95c9.png"
                    alt="セルフホワイトニング"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">セルフホワイトニング</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                ホワイトニングは、歯の黄ばみや汚れを落として自然な白さを取り戻すケアです。セルフでも簡単に行え、痛みが少なく安心です。
              </p>
            </div>

            {/* AIパーソナルモニター */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/a8affe22c590b8a6653d0d2ca9960cce.png"
                    alt="AIパーソナルモニター"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">AIパーソナルモニター</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                AIパーソナルモニターは姿勢や体の歪みをAIが分析し、最適なトレーニングを提案するシステムです。数値化された変化を可視化し、効率的に理想の体へ導きます。
              </p>
            </div>

            {/* トレーニングメニュー製作 */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/3cf3a25de983cc2a5c78730172485bd0.png"
                    alt="トレーニングメニュー製作"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">トレーニングメニュー製作</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                トレーニングメニュー制作は、目的や体の状態に合わせて最適な運動プログラムを作成するサービスです。AIや専門知識を活用し、無理なく続けられるプランを提案します。
              </p>
            </div>

            {/* バーチャルフィットネス */}
            <div className="bg-white rounded-3xl p-6 shadow-lg border border-gray-100">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://static.readdy.ai/image/743e16593bef7c5ad603d6aaf82a32e4/4bf530c7f07608eaede7feeefffb02c2.png"
                    alt="バーチャルフィットネス"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">バーチャルフィットネス</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                バーチャルトレーニングは、映像やAIを使って仮想空間で運動できる新感覚のフィットネスです。リアルな動きや効果を体感しながら楽しく続けられます。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-yellow-200">
        <div className="max-w-7xl mx-auto px-4">
          <h3 className="text-4xl font-bold text-center text-gray-900 mb-16">選ばれる理由</h3>
          <div className="grid md:grid-cols-3 gap-8">
            {/* カンタン！ */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Happy%20young%20Japanese%20woman%20using%20smartphone%20app%20for%20beauty%20salon%20booking%2C%20smiling%20while%20looking%20at%20phone%20screen%2C%20modern%20clean%20background%2C%20bright%20lighting%2C%20user-friendly%20interface%20visible&width=400&height=300&seq=reason1&orientation=landscape"
                    alt="スマホで簡単予約"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-2 -left-2 bg-yellow-300 rounded-full px-4 py-2 transform -rotate-12">
                  <span className="text-lg font-bold text-gray-900">カンタン！</span>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed">
                無人セルフマートは、誰でも簡単に使えるセルフサービス。予約から施術まで全て自分のペースで完結。面倒な手続きもなく、スマホひとつでスムーズに利用できます。
                <div className="text-xs text-gray-500 mt-4">
                  ※24時間営業の店舗は一部、テナント規制により例外がある場合があります
                </div>
              </div>
            </div>

            {/* 便利！ */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Japanese%20businessman%20in%20suit%20using%20smartphone%20while%20walking%2C%20professional%20office%20worker%20checking%20mobile%20phone%2C%20modern%20urban%20setting%2C%20convenient%20mobile%20technology%20usage%2C%20business%20person%20multitasking&width=400&height=300&seq=reason2business&orientation=landscape"
                    alt="24時間利用可能"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-2 -left-2 bg-yellow-300 rounded-full px-4 py-2 transform -rotate-12">
                  <span className="text-lg font-bold text-gray-900">便利！</span>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed">
                無人セルフマートは、24時間いつでも利用可能。仕事帰りやスキマ時間にも立ち寄れます。完全セルフだから待ち時間もなく、自分の予定に合わせて自由にケアできます。
              </div>
            </div>

            {/* 安心！ */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="relative mb-6">
                <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=Safe%20environment%20with%20security%20cameras%20and%20automatic%20lock%20systems%2C%20modern%20facility%20interior%20lighting%2C%20professional%20design%20comfort%20safety&width=400&height=300&seq=reason3&orientation=landscape"
                    alt="安全・安心"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-2 -left-2 bg-yellow-300 rounded-full px-4 py-2 transform -rotate-12">
                  <span className="text-lg font-bold text-gray-900">安心！</span>
                </div>
              </div>
              <div className="text-gray-700 leading-relaxed">
                完全個室・自動ロック・防犯カメラ・AI監視といった安全機能が充実。プライバシーとセキュリティを徹底し、安心して利用できます。
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h3 className="text-4xl font-bold text-center text-gray-900 mb-8">安心・安全への取り組み</h3>
          <p className="text-center text-xl text-gray-600 mb-16">人がいなくても、安心がある。その</p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {safetyFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-6 text-center hover:shadow-md transition-shadow"
              >
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                  <i className={`${feature.icon} text-3xl text-teal-600`} />
                </div>
                <h4 className="text-lg font-bold text-gray-900">{feature.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="max-w-6xl mx-auto px-4 text-center">
          {/* Store Information */}
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="text-left">
              <h4 className="text-xl font-bold mb-4">店舗情報</h4>
              <div className="space-y-4">
                <div className="border-b border-gray-600 pb-4">
                  <p className="flex items-center mb-2">
                    <i className="ri-map-pin-line mr-2" />
                    〒080-0026 帯広市西16条南6丁目13-6 アビタあかしや2 101号室
                  </p>
                  <p className="flex items-center">
                    <i className="ri-time-line mr-2" />
                    10:00-22:00（年中無休）
                  </p>
                  <p className="flex items-center">
                    <i className="ri-phone-line mr-2" />
                    ０８０－９６１１－４６９１
                  </p>
                  <p className="flex items-center">
                    <i className="ri-car-line mr-2" />
                    駐車場完備（無料）
                  </p>
                </div>
                <div>
                  <p className="flex items-center mb-2">
                    <i className="ri-map-pin-line mr-2" />
                    〒080-2469 帯広市西19条3丁目11-4
                  </p>
                  <p className="flex items-center">
                    <i className="ri-time-line mr-2" />
                    10:00-24:00（年中無休）
                  </p>
                  <p className="flex items-center">
                    <i className="ri-phone-line mr-2" />
                    ０８０－９６１１－４６９１
                  </p>
                  <p className="flex items-center">
                    <i className="ri-car-line mr-2" />
                    駐車場完備（無料）
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-xl font-bold mb-4">アクセス</h4>
              <div className="w-full h-48 rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.123456789!2d143.2045!3d42.9237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0b2b1234567890%3A0x1234567890abcdef!2z5bix5bqD5biC!5e0!3m2!1sja!2sjp!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-600 pt-4">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
